import React, { useState } from "react";
import { Modal, Textarea, Progress, Button, Group, Divider, Text } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import FileUploadZone from "./FileUploadZone";
import AttachmentButton from "../molecules/AttachmentButton";
import UploadedFilesList from "./UploadedFilesList";

export default function AIPromptModal({ 
  opened, 
  onClose, 
  onStartGenerating,
  aiPrompt,
  setAIPrompt
}) {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleStartGenerating = () => {
    if (onStartGenerating) {
      console.log("🔍 DEBUG: Starting generation with files:", uploadedFiles);
      onStartGenerating({
        prompt: uploadedFiles.length > 0 ? "" : aiPrompt,
        files: uploadedFiles
      });
      setUploadedFiles([]);
    }
  };

  const handleClose = () => {
    setUploadedFiles([]);
    if (onClose) {
      onClose();
    }
  };

  const handleFilesUploaded = (files) => {
    setUploadedFiles(files);
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="What do you want to create?"
      withCloseButton={true}
      closeOnClickOutside={false}
      closeOnEscape={false}
      overflow="inside"
      withinPortal={false}
      trapFocus={false}
      zIndex={99999}
      padding={0}
      styles={{
        header: { padding: "20px 20px 0 20px", marginBottom: 0 },
        title: { fontWeight: "600", fontSize: 18 }
      }}
    >
      <FileUploadZone
        onFilesUploaded={handleFilesUploaded}
        maxFiles={5}
        acceptedTypes={["pdf", "video"]}
      >
        <Textarea
          placeholder={"Describe what you want OR paste a link to a blog post"}
          data-autofocus
          value={aiPrompt}
          onChange={(event) => setAIPrompt(event.currentTarget.value)}
          minRows={5}
          maxRows={5}
          mb={20}
          disabled={uploadedFiles.length > 0}
          styles={{
            input: {
              opacity: uploadedFiles.length > 0 ? 0.5 : 1,
              backgroundColor: uploadedFiles.length > 0 ? '#f8f9fa' : 'white',
              cursor: uploadedFiles.length > 0 ? 'not-allowed' : 'text'
            }
          }}
        />

        <Progress
          value={aiPrompt.length * 2}
          mt={20}
          color={uploadedFiles.length > 0 ? "gray" : "blue"}
        />
        
        <Divider 
          my={20} 
          label={<Text size="sm" color="dimmed" weight={500}>OR upload a video or PDF</Text>}
          labelPosition="center"
        />
        
        <UploadedFilesList
          showTitle={false}
          files={uploadedFiles}
          onRemoveFile={(fileId) => {
            setUploadedFiles(prev => prev.filter(file => file.id !== fileId));
          }}
        />

        <Group mt={20}>
          <AttachmentButton 
            size="lg" 
            color="gray"
            tooltipText="Attach PDF or video file"
          />
          
          <Button
            size="lg"
            disabled={(aiPrompt.length >= 25 && aiPrompt.length <= 3000) || uploadedFiles.length > 0 ? false : true}
            leftIcon={<FontAwesomeIcon icon={solid("wand-magic-sparkles")} />}
            sx={{ flex: 1 }}
            onClick={handleStartGenerating}
          >
            {"Start generating"}
          </Button>
        </Group>
      </FileUploadZone>
    </Modal>
  );
}
